<template>
  <div class="find-wonderful-box">
    <!-- 表格数据 -->
    <el-table :data="tableData" border style="width: 100%" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
      <el-table-column prop="" label="增加时间" align="center"></el-table-column>
      <el-table-column prop="" label="排序" align="center"></el-table-column>
      <el-table-column prop="" label="标签名称" align="center"></el-table-column>
      <el-table-column prop="" label="封面" align="center">
        <template slot-scope="scope">
          <img-load :width="'60px'" :height="'80px'" :src="imgUrl + scope.row.cover"></img-load>
        </template>
      </el-table-column>
      <el-table-column prop="" label="状态" align="center">
        <el-switch v-model="params.turnOn"></el-switch>
      </el-table-column>
      <el-table-column prop="operating" label="操作" align="center" width="200">
        <template slot-scope="scope">
          <el-button type="success" size="mini" @click="editWonderful('edit',scope.row)">编辑</el-button>
          <el-button type="danger" size="mini">解除</el-button>
        </template>
      </el-table-column>
    </el-table>
     <!--分页组件-->
    <el-pagination :page-sizes="[10, 15, 20, 25]" :current-page="params.pageNumber" :page-size="params.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" background v-if="total > 10" @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
    <!-- 编辑弹窗 -->
    <edit-wonderful ref="editWonderful" @handlerWonderfulList="handlerWonderfulList"></edit-wonderful>
  </div>
</template>
<script>
import baseConfig from '@/utils/serverUrlConfig'
import EditWonderful from './components/editWonderful'
import API from '@/api'
export default {
  data() {
    return {
      total: 0,
      loading: false,
      tableData: [1],
      imgUrl: baseConfig.imgUrl,
      params: {
        pageNumber: 1,
        pageSize: 10,
        turnOn: false
      }
    }
  },
  created() {
    // this.getWonderfulList()
  },
  components: {
    EditWonderful
  },
  methods: {
    // 请求发现精彩列表数据
    getWonderfulList() {
      this.loading = true
      API.getWonderfulList(this.params).then(res => {
        if (res.code === 200 && res.data) {
          this.tableData = res.data
          this.total = res.data.total
        } else {
          this.tableData = []
          this.total = 0
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 监听编辑成功过后重新拉去数据
    handlerWonderfulList() {
      this.param.pageNumber = 1
      this.param.pageSize = 10
      this.getWonderfulList()
    },
    // 编辑弹窗
    editWonderful(type,row) {
      this.$refs.editWonderful.open(type,row)
    },
     // 分页条数改变回掉
    changeSize(size) {
      this.params.pageSize = size
      this.getWonderfulList()
    },
    // 分页页码改变回掉
    changeCurrent(number) {
      this.params.pageNumber = number
      this.getWonderfulList()
    },
  }
}
</script>
